/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Nov 06 2024
 **/

/**
 * 강제 퇴장 상태
 */
export type IsForceKickOut = {
	is_force_kick_out?: {
		cause: string;
		spaceID: SPACE_ID;
		spaceType: FE_SPACE_TYPE;
	};
};

export type SpaceStates = {
	space: IsForceKickOut;
};

export interface SpaceDispatch {
	initialize(): Promise<void>;
	get_space(spaceID: SPACE_ID): V2.SpaceInfo | null;
	set_space(spaceID: SPACE_ID, spaceInfo: V2.SpaceInfo): void;
	update_space(spaceID: SPACE_ID, spaceInfo: Partial<V2.SpaceInfo>): void;
	update_pin(spaceID: SPACE_ID): Promise<void>;
	update_space_chat_notification(spaceID: SPACE_ID): Promise<void>;
	refresh_space(spaceID: SPACE_ID): Promise<V2.SpaceInfo | null | undefined>;
}

export const InitialSpaceStates: SpaceStates = {
	space: {}
};
